<template>
  <div>
    <div class="field has-addons">
      <div class="control is-expanded">
        <input
          class="input"
          type="text"
          v-bind:value="link"
          ref="input"
        >
      </div>
      <div class="control">
        <a class="button is-primary " v-on:click="copyLink">
          {{ buttonMessage }}
        </a>
      </div>
    </div>
  </div>
</template>

<script>
  export default {
    data() {
      return {
        buttonMessage: 'Copy Link'
      }
    },
    components: {},
    props: {
      link: String
    },
    methods: {
      copyLink: function() {
        var self = this;
        this.$refs.input.select();
        this.$refs.input.setSelectionRange(0, 99999);
        document.execCommand('copy');

        this.buttonMessage = 'Copied!';

        window.setTimeout(() => {
          self.buttonMessage = 'Copy Link';
        }, 2000);
      }
    },
    computed: {},
    created: function() {},
  }
</script>

<style scoped>
  input {
    border: 1px solid #cccccc;
  }
</style>
